import { motion } from "framer-motion";
import { item } from "../../../utils/animations";
import styles from './ProblemCard.module.css';

export type ProblemCardProps = {
    image: string;
    description: string;
    color: string;
}

export const ProblemCard = ({image, description, color}: ProblemCardProps) => {
    return (
        <motion.div
            className={styles.card}
            variants={item}
            style={{ backgroundColor: color }}
        >
            <img
                src={image}
                alt="Problem Card"
                className={styles.image}
            />

            <div
                className={styles.content}
            >
                <p className={styles.text}>
                    {description}
                </p>
            </div>
        </motion.div>
    )
}